import { bool, string, func, object } from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { createFragmentContainer, graphql } from 'react-relay';
import get from 'lodash.get';
import { isMasqueradingAsBuyer } from 'dibs-cookie-jar';
import { localStorage } from 'dibs-browser-storage';
import { FormattedMessage } from 'react-intl';

import AccountIcon from 'dibs-vg/dist/react/account-outlined';
import MaskIcon from 'dibs-vg/dist/react/mask';
import Dropdown, { alignConstants, sizeConstants } from '../Dropdown/Dropdown';
import DropdownBody from '../Dropdown/DropdownBody';
import AccountNavContent from './AccountNavContent';
import authModalLoader from "../../utils/AuthModalLoader";

import { ACTION_REGISTER, ACTION_LOGIN } from './accountConstants';
import styles from './AccountNav-style.scss';
import { actionCreators } from '../../actions';

const AccountNavTrigger = ({ isMasquerading, name }) => {
    return (
        <div data-tn='user-menu-logged-in' className={styles.label}>
            <div data-tn='user-menu-logged-in-name' className={styles.name}>
                {isMasquerading ?
                    <span data-tn='user-menu-masq-icon' className={styles.maskIcon}>
                        <MaskIcon/>
                    </span> : null
                }
                {isMasquerading ? <span>({name})</span> : name}
            </div>
            <div className={styles.accountIcon}>
                <AccountIcon/>
            </div>
        </div>
    );
};

AccountNavTrigger.propTypes = {
    isMasquerading: bool,
    name: string
};

class AccountNav extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            isMasquerading: false
        };
        this.handleClick = this.handleClick.bind(this);
    }

    componentDidMount() {
        this.setState({ // eslint-disable-line react/no-did-mount-set-state
            isMasquerading: isMasqueradingAsBuyer(document.cookie)
        });
    }

    handleClick(e) {
        e.preventDefault();
        const action = e.currentTarget.dataset.action;
        Promise.resolve(authModalLoader.show(
            {
                relayEnvironment: this.props.relay.environment,
                email: localStorage.getItem('userEmail'),
                action,
                ga:
                {
                    label: `${action} link - global header`,
                    value: !!window.scrollY
                }
            }
        )).then(() => {
            this.props.dispatch(actionCreators.setUpdateUserState(true));
        }).catch((err) => {
            console.warn('Auth Modal could not be loaded\n', err);
        });
    }

    render() {
        const { hasUser, hasUserId, isClient, user } = this.props;

        if (!isClient || hasUserId && !hasUser) {
            return null;
        }

        const name = get(user, 'profile.firstName') ||
            <FormattedMessage
                id='dbl.Header.AccountNav.name'
                defaultMessage={'My Account'}
            />;

        const totalUnreadConversations = get(user, 'conversationSummary.totalUnreadConversationCount', 0);
        const tradeLoyaltyStatus = get(user, 'tradeFirm.loyalty.status') || '';

        return (
            <div data-tn="account-nav" className={styles.wrapper}>
            { hasUser ?
                <Dropdown align={alignConstants.ALIGN_CENTER} size={sizeConstants.SIZE_SMALL}>
                    <AccountNavTrigger isMasquerading={this.state.isMasquerading} name={name}/>
                    <DropdownBody>
                        <AccountNavContent
                            totalUnreadConversations={totalUnreadConversations}
                            tradeLoyaltyStatus={tradeLoyaltyStatus}
                        />
                    </DropdownBody>
                </Dropdown> :
                <div className={styles.authLinks}>
                    <span
                        className={styles.authLink}
                        data-tn='user-menu-nav-item-link-log-in'
                        data-action={ACTION_LOGIN}
                        onClick={this.handleClick}
                    >
                        <FormattedMessage
                            id='dbl.Header.AccountNav.log_in'
                            defaultMessage={'Log In'}
                        />
                    </span>
                    <span
                        className={styles.authLink}
                        data-tn='user-menu-nav-item-link-sign-up'
                        data-action={ACTION_REGISTER}
                        onClick={this.handleClick}
                    >
                        <FormattedMessage
                            id='dbl.Header.AccountNav.sign_up'
                            defaultMessage={'Sign Up'}
                        />
                    </span>
                </div>
            }
            </div>
        );
    }
}

AccountNav.propTypes = {
    hasUser: bool,
    hasUserId: bool,
    isClient: bool,
    user: object,
    viewer: object,
    relay: object,
    dispatch: func
};


export default createFragmentContainer(
    connect(() => { return {}; })(AccountNav), // for dispatch
    {
        user: graphql`
            fragment AccountNav_user on User {
                profile {
                    firstName
                }
                conversationSummary {
                    totalUnreadConversationCount
                }
                tradeFirm {
                    loyalty {
                        status
                    }
                }
            }
        `
    }
);



// WEBPACK FOOTER //
// ./src/components/AccountNav/AccountNav.jsx